module.exports = __webpack_public_path__ + "static/media/close-register.29ed45bd.PNG";